import { useEffect, useState } from 'react';

import { chargeBoxesWithKeys, SimChargeBox, SimScenario, withKeys } from './scenario';

import {
  getSmartChargingSimulationChargeBoxes,
  getSmartChargingSimulationScenario,
} from '../../../hooks/smartcharging';

type Props = {
  smartChargingId?: string | null;
  chargeBoxIds?: string[];
};

/**
 * Estações do grupo com fase/rotação, para o aviso do formulário e o ponto de partida do
 * simulador. Grupo existente: cenário completo (limite, medidor, quem está carregando).
 * Grupo novo: só as estações escolhidas.
 */
export const useSmartChargingStations = ({ smartChargingId, chargeBoxIds }: Props) => {
  const [groupScenario, setGroupScenario] = useState<SimScenario | null>(null);
  const [chargeBoxes, setChargeBoxes] = useState<SimChargeBox[]>([]);
  // A lista chega como array novo a cada render; a string evita buscar de novo à toa
  const idsKey = (chargeBoxIds || []).filter(Boolean).join(',');

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        if (smartChargingId) {
          const { data } = await getSmartChargingSimulationScenario(smartChargingId);
          if (active) {
            const scenario = withKeys(data);
            setGroupScenario(scenario);
            setChargeBoxes(scenario.charge_boxes);
          }
          return;
        }

        if (idsKey) {
          const { data } = await getSmartChargingSimulationChargeBoxes(idsKey.split(','));
          if (active) {
            setGroupScenario(null);
            setChargeBoxes(chargeBoxesWithKeys(data));
          }
          return;
        }

        if (active) {
          setGroupScenario(null);
          setChargeBoxes([]);
        }
      } catch {
        // Sem a lista, o formulário só deixa de mostrar o aviso; o simulador abre no exemplo
        if (active) {
          setGroupScenario(null);
          setChargeBoxes([]);
        }
      }
    })();

    return () => {
      active = false;
    };
  }, [smartChargingId, idsKey]);

  return { groupScenario, chargeBoxes };
};
